import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { useParams, useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import {
  Row,
  Col,
  Button,
  Card,
  Modal,
  DatePicker,
  TimePicker,
  Table,
  Select,
  Form,
  Input,
  Breadcrumb,
  Steps,
  Typography,
  Avatar,
  message,
  Upload,
  Space,
  Popconfirm,
} from "antd";
import {
  DoubleRightOutlined,
  PhoneOutlined,
  MailOutlined,
  InboxOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  SignatureFilled,
  LoadingOutlined,
} from "@ant-design/icons";
import { FormattedMessage, useIntl } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import logoicon from "../../../logoicon.png";
import {
  getAppointmentById,
  getFieldStatusesByAppointmentId,
  addAppointmentFieldStatus,
  updateAppointmentFieldStatus,
  deleteAppointmentFieldStatus,
  updateAppointmentNotes,
  updateAppointmentStatus,
} from "./AppointmentApi";
import AttachmentComponent from "CommonComponents/Attachments/Attachments";
import FormType from "features/Enums/FormType";
import StatusEnum from "features/Enums/StatusEnum";
import { addFile } from "CommonComponents/Attachments/AttachmentsSlice";
import {
  faUser,
  faFileInvoiceDollar,
  faPause,
  faShippingFast,
  faStop,
  faHashtag,
  faSmile,
  faEnvelope,
  faPhone,
  faPlay,
} from "@fortawesome/free-solid-svg-icons";
import WorkOrderProducts from "features/Clients/Components/WorkOrderProducts";
import Signature from "CommonComponents/Signature";
import { signatureUploadAttachment } from "CommonComponents/Attachments/AttachmentsAPI";
import { getTechniciansAPI } from "CommonComponents/Lookup/LookupAPI";
function AppointmentDetails() {
  const intl = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [form1] = Form.useForm();
  const { companyId, clientId, partnerId, workOrderId, appointmentId } =
    useParams();
  const { Column } = Table;
  const { TextArea } = Input;
  const { Text } = Typography;
  const { Option } = Select;
  const { Dragger } = Upload;
  const { Step } = Steps;
  const [editFieldStatus, setEditFieldStatus] = useState(null);
  const [showSignatureModal, setShowSignatureModal] = useState(false);
  const [savingNotes, setSavingNotes] = useState(false);
  const [isNotesChanged, setIsNotesChanged] = useState(false);
  const [areAttachmentsChanged, setAreAttachmentsChanged] = useState(false);
  const [updatingStatus, setUpdatingStatus] = useState(false);
  const techniciansList = useSelector((state) => state.lookup.technicians);
  const appointment = useSelector(
    (state) => state.appointments.appointmentDetails
  );
  const techFieldList = useSelector(
    (state) => state.appointments.techFieldList
  );
  const formTypeId = Object.values(FormType).find(
    (f) => f.name === "Appointments"
  )?.id;

  const [isFieldModalOpen, setIsFieldModalOpen] = useState(false);

  const showFieldModal = () => setIsFieldModalOpen(true);
  const closeFieldModal = () => setIsFieldModalOpen(false);
  const [current, setCurrent] = useState(null);

  const SaveSignature = (statusId, signatureData) => {
    setShowSignatureModal(true);
  };
  const isPaused =
    appointment?.data?.appointmentStatusId === StatusEnum.Paused.id;

  // const orderSteps = [
  //   {
  //     title: <FormattedMessage id="Appointment.OnMyWay" />,
  //     icon: <FontAwesomeIcon icon={faShippingFast} />,
  //     fullDescription: (
  //       <>
  //         <Text>
  //           <FormattedMessage id="Appointment.TechnicianOnMyWay" />
  //         </Text>
  //         <br />
  //         <Text type="secondary">
  //           {dayjs(appointment?.data?.onMyWayAt).format(
  //             "ddd, DD MMM YYYY – h:mmA"
  //           )}
  //         </Text>
  //       </>
  //     ),
  //   },
  //   {
  //     title: <FormattedMessage id="Appointment.Started" />,
  //     icon: <FontAwesomeIcon icon={faPlay} />,
  //     fullDescription: (
  //       <>
  //         <Text>
  //           <FormattedMessage id="Appointment.AppointmentStarted" />
  //         </Text>
  //         <br />
  //         <Text type="secondary">
  //           {dayjs(appointment?.data?.startedAt).format(
  //             "ddd, DD MMM YYYY – h:mmA"
  //           )}
  //         </Text>
  //       </>
  //     ),
  //   },
  //   {
  //     title: isPaused ? (
  //       <FormattedMessage id="Appointment.Resume" />
  //     ) : (
  //       <FormattedMessage id="Appointment.Paused" />
  //     ),
  //     icon: isPaused ? (
  //       <FontAwesomeIcon icon={faPlay} />
  //     ) : (
  //       <FontAwesomeIcon icon={faPause} />
  //     ),
  //     fullDescription: isPaused ? (
  //       <>
  //         <Text>
  //           <FormattedMessage id="Appointment.AppointmentPaused" />
  //         </Text>
  //         <br />
  //         <Text type="secondary">
  //           {appointment?.data?.pausedAt
  //             ? dayjs(appointment.data.pausedAt).format(
  //                 "ddd, DD MMM YYYY – h:mmA"
  //               )
  //             : ""}
  //         </Text>
  //       </>
  //     ) : (
  //       <>
  //         <Text>
  //           <FormattedMessage id="Appointment.AppointmentResumed" />
  //         </Text>
  //         <br />
  //         <Text type="secondary">
  //           {appointment?.data?.resumedAt
  //             ? dayjs(appointment.data.resumedAt).format(
  //                 "ddd, DD MMM YYYY – h:mmA"
  //               )
  //             : ""}
  //         </Text>
  //       </>
  //     ),
  //   },
  //   {
  //     title: <FormattedMessage id="Appointment.Completed" />,
  //     icon: <FontAwesomeIcon icon={faSmile} />,
  //     fullDescription: (
  //       <>
  //         <Text>
  //           <FormattedMessage id="Appointment.AppointmentCompleted" />
  //         </Text>
  //         <br />
  //         <Text type="secondary">
  //           {dayjs(appointment?.data?.completedAt).format(
  //             "ddd, DD MMM YYYY – h:mmA"
  //           )}
  //         </Text>
  //       </>
  //     ),
  //   },
  // ];
  const renderCustomSteps = () => {
    const steps = [
      {
        id: 0,
        title: <FormattedMessage id="Appointment.OnMyWay" />,
        icon: <FontAwesomeIcon icon={faShippingFast} />,
        description: <FormattedMessage id="Appointment.TechnicianOnMyWay" />,
        timestamp: appointment?.data?.onMyWayAt,
        isSpecial: false,
      },
      {
        id: 1,
        title: <FormattedMessage id="Appointment.Started" />,
        icon: <FontAwesomeIcon icon={faPlay} />,
        description: <FormattedMessage id="Appointment.AppointmentStarted" />,
        timestamp: appointment?.data?.startedAt,
        isSpecial: false,
      },
      {
        id: 2,
        title: isPaused ? (
          <FormattedMessage id="Appointment.Resume" />
        ) : (
          <FormattedMessage id="Appointment.Paused" />
        ),
        icon: <FontAwesomeIcon icon={isPaused ? faPlay : faPause} />,
        description: isPaused ? (
          <FormattedMessage id="Appointment.AppointmentPaused" />
        ) : (
          <FormattedMessage id="Appointment.AppointmentResumed" />
        ),
        timestamp: isPaused
          ? appointment?.data?.pausedAt
          : appointment?.data?.resumedAt,
        isSpecial: true,
      },
      {
        id: 3,
        title: <FormattedMessage id="Appointment.Completed" />,
        icon: <FontAwesomeIcon icon={faSmile} />,
        description: <FormattedMessage id="Appointment.AppointmentCompleted" />,
        timestamp: appointment?.data?.completedAt,
        isSpecial: false,
      },
    ];

    const getStepStatus = (stepId) => {
      if (current === null) return "pending";
      if (stepId < current) return "completed";
      if (stepId === current) return "current";
      if (stepId === 2 && current === 2) return "current";
      return "pending";
    };

    const isStepClickable = (step) => {
      if (appointment?.data?.appointmentStatusId === StatusEnum.Completed.id) {
        return false;
      }
      if (step.isSpecial) {
        return current === 1 || current === 2;
      }

      if (current === null) {
        return step.id === 0;
      }

      return step.id <= current + 1 && step.id >= 0;
    };

    const handleStepClick = (step) => {
      if (!isStepClickable(step) || updatingStatus) return;

      if (step.isSpecial) {
        handlePauseResume();
      } else {
        onChange(step.id);
      }
    };

    return (
      <div className="custom-steps-container">
        <div className="steps-wrapper">
          {steps.map((step, index) => {
            const status = getStepStatus(step.id);
            const isClickable = isStepClickable(step);
            const isActive = status === "current";
            const isCompleted = status === "completed";

            return (
              <div key={step.id} className="step-item">
                <div
                  className={`step-circle ${!isClickable ? "disabled" : ""}`}
                  onClick={() => handleStepClick(step)}
                  style={{
                    backgroundColor:
                      isCompleted || isActive ? "#1890ff" : "white",
                    border: `2px solid ${
                      isCompleted || isActive ? "#1890ff" : "#d9d9d9"
                    }`,
                    cursor: isClickable ? "pointer" : "not-allowed",
                    color: isCompleted || isActive ? "white" : "#d9d9d9",
                  }}
                >
                  {updatingStatus && isActive ? (
                    <LoadingOutlined style={{ fontSize: 14 }} />
                  ) : (
                    <span style={{ fontSize: 12 }}>{step.icon}</span>
                  )}
                </div>

                {index < steps.length - 1 && (
                  <div
                    className="step-line"
                    style={{
                      backgroundColor:
                        current > step.id ? "#1890ff" : "#d9d9d9",
                    }}
                  />
                )}

                <div className="step-content">
                  <div
                    className="step-title"
                    style={{
                      color: isActive ? "#1890ff" : "rgba(0,0,0,0.85)",
                      fontWeight: isActive ? 600 : 400,
                    }}
                  >
                    {step.title}
                  </div>

                  {(isCompleted || isActive) && (
                    <div className="step-description">
                      <div>{step.description}</div>
                      {step.timestamp && (
                        <div className="step-timestamp">
                          {dayjs(step.timestamp).format(
                            "ddd, DD MMM YYYY – h:mmA"
                          )}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  const handleSignatureSubmit = async (signatureData) => {
    try {
      const formTypeId = FormType.AppointmentSignature.id;
      const signatureBase64Object = {
        fileName: "signature.png",
        base64: signatureData.signature,
        identifier: formTypeId,
      };

      await dispatch(addFile(signatureBase64Object));
      await dispatch(signatureUploadAttachment(appointmentId));

      await dispatch(
        updateAppointmentStatus(
          Number(appointmentId),
          Number(StatusEnum.Completed.id)
        )
      );

      setCurrent(3);
      setShowSignatureModal(false);
    } catch (error) {
      console.error("Error submitting signature:", error);
    }
  };

  const handlePauseResume = async () => {
    if (current === null || current < 1) {
      message.warning("Please start the appointment first");
      return;
    }

    setUpdatingStatus(true);

    try {
      const technicianStatusId = appointment?.data?.technicianStatusId;
      let newStatusId;

      if (
        appointment?.data?.appointmentStatusId === StatusEnum.Started.id ||
        appointment?.data?.appointmentStatusId === StatusEnum.Resumed.id
      ) {
        newStatusId = StatusEnum.Paused.id;
      } else if (
        appointment?.data?.appointmentStatusId === StatusEnum.Paused.id
      ) {
        newStatusId = StatusEnum.Resumed.id;
      } else {
        message.warning("Cannot pause/resume from current status");
        return;
      }

      console.log(
        "Updating status from:",
        appointment?.data?.appointmentStatusId,
        "to:",
        newStatusId
      );

      await dispatch(
        updateAppointmentStatus(
          Number(appointmentId),
          Number(newStatusId),
          Number(technicianStatusId)
        )
      );

      await dispatch(getAppointmentById(appointmentId));
    } catch (error) {
      console.error("Error updating pause/resume status:", error);
    } finally {
      setUpdatingStatus(false);
    }
  };

  const onChange = async (value) => {
    if (value === 2) {
      handlePauseResume();
      return;
    }

    if (current === null && value !== 0) {
      message.warning("Please start by selecting 'On My Way' first");
      return;
    }

    if (value < current) {
      message.warning("You cannot go back to previous steps");
      return;
    }

    if (value > current + 1) {
      message.warning("Please complete the current step first");
      return;
    }

    const statusMap = {
      0: StatusEnum.OnMyWay.id,
      1: StatusEnum.Started.id,
      3: StatusEnum.Completed.id,
    };

    const statusId = statusMap[value];

    if (statusId === undefined) {
      message.error("Unknown status selected");
      return;
    }

    const previousCurrent = current;
    setUpdatingStatus(true);

    try {
      if (statusId === StatusEnum.Completed.id) {
        setShowSignatureModal(true);
        return;
      }

      const technicianStatusId = appointment?.data?.technicianStatusId;
      await dispatch(
        updateAppointmentStatus(
          Number(appointmentId),
          Number(statusId),
          Number(technicianStatusId)
        )
      );

      setCurrent(value);
    } catch (error) {
      console.error("Error updating status:", error);
      setCurrent(previousCurrent);
    } finally {
      setUpdatingStatus(false);
    }
  };

  const handleSaveNotes = async () => {
    try {
      setSavingNotes(true);

      const values = await form1.validateFields(["notes"]);

      if (!appointmentId) {
        message.error("Appointment ID is missing");
        return;
      }

      await dispatch(
        updateAppointmentNotes({
          appointmentId: appointmentId,
          notes: values.notes,
        })
      );
    } catch (error) {
      console.error("Error saving notes:", error);
    } finally {
      setSavingNotes(false);
    }
  };

  const fieldStatusData =
    techFieldList?.data?.map((item, idx) => ({
      key: item.id || idx + 1,
      sno: idx + 1,
      date: item.date,
      ttraveltime: item.totalTravelTime,
      ttimeonjob: item.totalJobTime,
      id: item.id,
      technicianId: item.technicianId,
    })) || [];
  const handleFieldStatusSubmit = (values) => {
    const formattedDate = values.date ? values.date.format("YYYY-MM-DD") : "";
    const formattedTravelTime = values.totaltraveltime
      ? values.totaltraveltime.format("HH:mm:ss")
      : "";
    const formattedJobTime = values.totaljobtime
      ? values.totaljobtime.format("HH:mm:ss")
      : "";

    const payload = {
      appointmentId: Number(appointmentId),
      date: formattedDate,
      totalTravelTime: formattedTravelTime,
      totalJobTime: formattedJobTime,
      technicianId: Number(values.technicianId),
    };

    if (editFieldStatus) {
      dispatch(updateAppointmentFieldStatus(editFieldStatus.id, payload));
    } else {
      dispatch(addAppointmentFieldStatus(payload));
    }

    setIsFieldModalOpen(false);
    setEditFieldStatus(null);
    form.resetFields();
  };

  const handleDeleteFieldStatus = (id) => {
    dispatch(deleteAppointmentFieldStatus(id, appointmentId));
  };
  useEffect(() => {
    if (isFieldModalOpen && editFieldStatus) {
      form.setFieldsValue({
        date: dayjs(editFieldStatus.date),
        totaltraveltime: dayjs(editFieldStatus.ttraveltime, "HH:mm:ss"),
        totaljobtime: dayjs(editFieldStatus.ttimeonjob, "HH:mm:ss"),
        technicianId: editFieldStatus.technicianId,
      });
    } else if (isFieldModalOpen) {
      form.setFieldsValue({
        date: dayjs(),
        technicianId: undefined,
      });
      //form.setFieldsValue({ date: dayjs() });
      form.resetFields(["totaltraveltime", "totaljobtime"]);
    }
  }, [isFieldModalOpen, editFieldStatus, form]);

  useEffect(() => {
    if (appointmentId) {
      dispatch(getAppointmentById(appointmentId));
      dispatch(getFieldStatusesByAppointmentId(appointmentId));
    }
    dispatch(getTechniciansAPI());
  }, [dispatch, appointmentId]);
  useEffect(() => {
    if (appointment) {
      const notes = appointment?.data?.notes || "";
      form1.setFieldsValue({ notes });
      setIsNotesChanged(false);
    }
  }, [appointment, form1]);
  useEffect(() => {
    if (appointment?.data?.appointmentStatusId) {
      switch (appointment.data.appointmentStatusId) {
        case StatusEnum.OnMyWay.id:
          setCurrent(0);
          break;
        case StatusEnum.Started.id:
          setCurrent(1);
          break;
        case StatusEnum.Paused.id:
          setCurrent(2);
          break;
        case StatusEnum.Resumed.id:
          setCurrent(2);
          break;
        case StatusEnum.Completed.id:
          setCurrent(3);
          break;
        default:
          setCurrent(null);
      }
    }
  }, [appointment]);
  return (
    <div className="medispamain" style={{ position: "relative" }}>
      <div className="main-area">
        <div className="title-part">
          <Row align="middle" justify="space-between">
            <Col>
              <h4>
                <FormattedMessage id="Appointment.AppointmentNumber" /> -{" "}
                {appointment?.data?.appointmentNumber}
              </h4>
            </Col>
            <Col className="text-right">
              <Breadcrumb
                separator={<DoubleRightOutlined />}
                items={[
                  {
                    title: partnerId ? (
                      <FormattedMessage id="PartnerClient.PartnerClientDetails" />
                    ) : (
                      <FormattedMessage id="ClientDetails.ClientDetails" />
                    ),
                    href:
                      partnerId && clientId
                        ? `/${companyId}/${partnerId}/partner_client_details/${clientId}/client_details`
                        : partnerId
                        ? `/${companyId}/${partnerId}/partner_client_details`
                        : `/${companyId}/${clientId}/client_details`,
                  },
                  {
                    title: (
                      <FormattedMessage id="WorkOrderDetails.WorkOrderDetails" />
                    ),
                    href:
                      partnerId && clientId
                        ? `/${companyId}/${partnerId}/partner_client_details/${clientId}/client_details/wo_details/${workOrderId}`
                        : partnerId
                        ? `/${companyId}/${partnerId}/partner_client_details/wo_details/${workOrderId}`
                        : `/${companyId}/${clientId}/client_details/wo_details/${workOrderId}`,
                  },
                  {
                    title: (
                      <FormattedMessage id="AppointmentDetails.AppointmentDetails" />
                    ),
                  },
                ]}
              />
            </Col>
          </Row>
        </div>
        <Card className="appointment-card">
          <Row align="middle" justify="start" gutter={[16, 16]}>
            <Col xs={24}>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 12,
                  flexWrap: "wrap", // ✅ allows wrapping on mobile
                }}
              >
                {/* Avatar - Fixed width */}
                <div style={{ width: 48, flexShrink: 0 }}>
                  <Avatar
                    style={{
                      backgroundColor: "#3a5892",
                      verticalAlign: "middle",
                      width: 48,
                      height: 48,
                      fontSize: 18,
                    }}
                  >
                    {appointment?.data?.partnerClientDetails?.companyName
                      ?.charAt(0)
                      .toUpperCase() ||
                      appointment?.data?.clientDetails?.name
                        ?.charAt(0)
                        .toUpperCase() ||
                      ""}
                  </Avatar>
                </div>

                {/* Client Info */}
                <div style={{ flex: 1, minWidth: 0 }}>
                  <h4
                    className="word-break"
                    style={{
                      fontWeight: "bold",
                      marginBottom: 4,
                      wordBreak: "break-word",
                    }}
                  >
                    {appointment?.data?.partnerClientDetails
                      ? appointment?.data?.partnerClientDetails?.companyName
                      : appointment?.data?.clientDetails?.isResidential
                      ? appointment?.data?.clientDetails?.name
                      : appointment?.data?.clientDetails?.companyName || ""}
                  </h4>

                  {/* ✅ Mobile-friendly contact info */}
                  <Space
                    size={[8, 4]}
                    wrap
                    style={{
                      display: "flex",
                      flexWrap: "wrap",
                      color: "#555",
                      fontSize: 13,
                    }}
                  >
                    <p style={{ margin: 0 }}>
                      <PhoneOutlined style={{ marginRight: 6 }} />
                      {appointment?.data?.partnerClientDetails?.phone?.trim() ||
                        appointment?.data?.clientDetails?.phone?.trim() ||
                        ""}
                    </p>
                    <p style={{ margin: 0 }} className="sm-d-none">
                      |
                    </p>
                    <p style={{ margin: 0, wordBreak: "break-all" }}>
                      <MailOutlined style={{ marginRight: 6 }} />
                      {appointment?.data?.partnerClientDetails?.email?.trim() ||
                        appointment?.data?.clientDetails?.email?.trim() ||
                        ""}
                    </p>
                  </Space>
                </div>
              </div>
            </Col>
          </Row>
        </Card>

        <Row gutter={[16, 16]} className="mt-10">
          <Col xs={24} sm={24} lg={19}>
            <Card size="small">{renderCustomSteps()}</Card>

            <div className="mt-10">
              <WorkOrderProducts appointmentId={appointmentId} />
            </div>

            <Signature
              visible={showSignatureModal}
              onCancel={() => setShowSignatureModal(false)}
              onSubmit={handleSignatureSubmit}
              title={<FormattedMessage id="Appointment.ClientSign" />}
              description={
                <FormattedMessage id="Appointment.SignatureHeadline" />
              }
              okText={<FormattedMessage id="Common.Submit" />}
              cancelText={<FormattedMessage id="Common.Cancel" />}
              requireName={true}
              showDate={true}
            />
            <Card className="mt-10">
              <Row justify="space-between" align="middle">
                <Col>
                  <h5>
                    <FormattedMessage id="Appointment.FieldTechStatus" />
                  </h5>
                </Col>
                <Col>
                  <Button size="small" type="primary" onClick={showFieldModal}>
                    <FormattedMessage id="Appointment.AddFieldStatus" />
                  </Button>
                </Col>
              </Row>
              <Modal
                title={
                  editFieldStatus ? (
                    <FormattedMessage id="Appointment.EditTechStatus" />
                  ) : (
                    <FormattedMessage id="Appointment.AddTechStatus" />
                  )
                }
                open={isFieldModalOpen}
                onCancel={() => {
                  setIsFieldModalOpen(false);
                  setEditFieldStatus(null);
                  form.resetFields();
                }}
                footer={null}
              >
                <Form
                  layout="vertical"
                  form={form}
                  onFinish={handleFieldStatusSubmit}
                  initialValues={{
                    date: !editFieldStatus ? dayjs() : undefined,
                  }}
                >
                  <Form.Item
                    label={
                      <FormattedMessage id="AddAppointment.SelectTechnician" />
                    }
                    name="technicianId"
                    rules={[
                      {
                        required: true,
                        message: intl.formatMessage({
                          id: "AddAppointment.Error.SelectTechnician",
                        }),
                      },
                    ]}
                  >
                    <Select
                      placeholder={intl.formatMessage({
                        id: "AddAppointment.SelectTechnician",
                      })}
                    >
                      {techniciansList
                        ?.filter((tech) =>
                          appointment?.data?.appointmentTechnicians?.some(
                            (appTech) => appTech.technicianId === tech.id
                          )
                        )
                        ?.map((tech) => (
                          <Option key={tech.id} value={tech.id}>
                            {`${tech.firstName || ""} ${tech.lastName || ""}`}
                          </Option>
                        ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    label={<FormattedMessage id="ClientDetails.Date" />}
                    name="date"
                    rules={[
                      {
                        required: true,
                        message: intl.formatMessage({
                          id: "Lead.Error.Date",
                        }),
                      },
                    ]}
                  >
                    <DatePicker
                      placeholder={intl.formatMessage({
                        id: "AddLeadCall.Placeholder.SelectDate",
                      })}
                      style={{ width: "100%" }}
                      disabledDate={(current) =>
                        current && current < dayjs().startOf("day")
                      }
                    />
                  </Form.Item>
                  <Form.Item
                    label={
                      <FormattedMessage id="Appointment.TotalTravelTimeHH" />
                    }
                    name="totaltraveltime"
                    rules={[
                      {
                        required: true,
                        message: intl.formatMessage({
                          id: "Appointment.Error.PleaseSelectTotalTravelTime",
                        }),
                      },
                    ]}
                  >
                    <TimePicker
                      format="HH:mm"
                      style={{ width: "100%" }}
                      placeholder={intl.formatMessage({
                        id: "Appointment.SelectTime",
                      })}
                      showNow={false}
                    />
                  </Form.Item>
                  <Form.Item
                    label={
                      <FormattedMessage id="Appointment.TotalTimeOnJobHH" />
                    }
                    name="totaljobtime"
                    rules={[
                      {
                        required: true,
                        message: intl.formatMessage({
                          id: "Appointment.Error.PleaseSelectTotalTimeOnJob",
                        }),
                      },
                    ]}
                  >
                    <TimePicker
                      format="HH:mm"
                      style={{ width: "100%" }}
                      placeholder={intl.formatMessage({
                        id: "Appointment.SelectTime",
                      })}
                      showNow={false}
                    />
                  </Form.Item>
                  <Form.Item className="text-center">
                    <Button type="primary" htmlType="submit">
                      {editFieldStatus ? (
                        <FormattedMessage id="Common.Save" />
                      ) : (
                        <FormattedMessage id="Common.Add" />
                      )}
                    </Button>
                  </Form.Item>
                </Form>
              </Modal>
              <Table
                dataSource={fieldStatusData}
                bordered
                scroll={{ x: 900 }}
                pagination={false}
                className="mt-10"
              >
                <Column
                  title={<FormattedMessage id="WorkOrderDetails.Sno" />}
                  dataIndex="sno"
                  key="sno"
                />
                <Column
                  title={<FormattedMessage id="Appointment.Technician" />}
                  dataIndex="technicianId"
                  key="technicianId"
                  render={(text, record) => {
                    const technician = techniciansList.find(
                      (tech) => tech.id === record.technicianId
                    );
                    return technician
                      ? `${technician.firstName || ""} ${
                          technician.lastName || ""
                        }`
                      : "";
                  }}
                />
                <Column
                  title={<FormattedMessage id="ClientDetails.Date" />}
                  dataIndex="date"
                  key="date"
                />
                <Column
                  title={<FormattedMessage id="Appointment.TotalTravelTime" />}
                  dataIndex="ttraveltime"
                  key="ttraveltime"
                />
                <Column
                  title={<FormattedMessage id="Appointment.TotalTimeOnJob" />}
                  dataIndex="ttimeonjob"
                  key="ttimeonjob"
                />
                <Column
                  title={<FormattedMessage id="Common.Action" />}
                  key="action"
                  render={(_, record) => (
                    <Space>
                      <Button
                        icon={<EditOutlined />}
                        size="small"
                        onClick={() => {
                          setEditFieldStatus(record);
                          setIsFieldModalOpen(true);
                        }}
                      />
                      <Popconfirm
                        title={
                          <FormattedMessage id="AddAppointment.PopDeleteMessage" />
                        }
                        description={
                          <FormattedMessage id="AddAppointment.PopDeleteContext" />
                        }
                        onConfirm={() => handleDeleteFieldStatus(record.id)}
                        okText={<FormattedMessage id="Common.Yes" />}
                        cancelText={<FormattedMessage id="Common.No" />}
                      >
                        <DeleteOutlined
                          style={{
                            color: "red",
                            fontSize: 16,
                            cursor: "pointer",
                          }}
                        />
                      </Popconfirm>
                    </Space>
                  )}
                />
              </Table>
            </Card>
            <Card className="mt-10">
              <Form layout="vertical" size="large" form={form1}>
                <Form.Item
                  label={<FormattedMessage id="Appointment.Notes" />}
                  name="notes"
                  rules={[
                    {
                      required: true,
                      message: intl.formatMessage({
                        id: "Appointment.Error.Notes",
                      }),
                    },
                  ]}
                >
                  <Input.TextArea
                    rows={3}
                    placeholder={intl.formatMessage({
                      id: "Appointment.Placeholder.EnterNotes",
                    })}
                    onChange={(e) => {
                      const originalNotes = appointment?.data?.notes || "";
                      setIsNotesChanged(e.target.value !== originalNotes);
                    }}
                  />
                </Form.Item>

                <Form.Item
                  label={<FormattedMessage id="AddEstimate.Attachments" />}
                  required
                >
                  <AttachmentComponent
                    identifier={formTypeId}
                    currentId={appointmentId}
                    getattachments={true}
                    onChange={() => setAreAttachmentsChanged(true)}
                  />
                </Form.Item>
                <Form.Item className="text-center">
                  <Button
                    type="primary"
                    size="medium"
                    onClick={handleSaveNotes}
                    loading={savingNotes}
                    disabled={!isNotesChanged && !areAttachmentsChanged}
                  >
                    <CheckCircleOutlined />
                    {<FormattedMessage id="Common.Submit" />}
                  </Button>
                  <Button
                    danger
                    size="medium"
                    style={{ marginLeft: "10px" }}
                    onClick={() =>
                      navigate(
                        `/${companyId}/${clientId}/client_details/wo_details/${workOrderId}`
                      )
                    }
                    disabled={!isNotesChanged && !areAttachmentsChanged}
                  >
                    <CloseCircleOutlined />{" "}
                    {<FormattedMessage id="Common.Cancel" />}
                  </Button>
                </Form.Item>
              </Form>
            </Card>
          </Col>
          <Col xs={24} sm={24} lg={5}>
            <Card
              title={<FormattedMessage id="Appointment.TechnicianDetails" />}
              size="small"
              className="new-comp-info"
            >
              {appointment?.data?.technicians &&
              appointment.data.technicians.length > 0 ? (
                appointment.data.technicians.map((tech, idx) => (
                  <div
                    key={tech.id || idx}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: 12,
                      marginBottom: 16,
                    }}
                  >
                    <Avatar
                      style={{
                        backgroundColor: "#f56a00",
                        verticalAlign: "middle",
                      }}
                      size="large"
                    >
                      {tech?.fullName?.charAt(0) || ""}
                    </Avatar>
                    <div>
                      <Typography.Text strong>{tech.fullName}</Typography.Text>
                      <br />
                      <Typography.Text type="secondary">
                        <FormattedMessage id="Appointment.Technician" />
                      </Typography.Text>
                      <br />
                      <span>
                        <FontAwesomeIcon icon={faEnvelope} /> &nbsp;
                        {tech.email}
                      </span>
                      <br />
                      <span>
                        <FontAwesomeIcon icon={faPhone} /> &nbsp;
                        {tech.phone}
                      </span>
                    </div>
                  </div>
                ))
              ) : (
                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                  <FontAwesomeIcon
                    icon={faUser}
                    style={{ color: "#aaa", fontSize: 20 }}
                  />
                  <p style={{ margin: 0 }}>No technicians assigned</p>
                </div>
              )}
            </Card>
            <Card
              title={
                <FormattedMessage id="WorkOrderDetails.WorkOrderDetails" />
              }
              size="small"
              className="new-comp-info mt-10"
            >
              <p>
                <FontAwesomeIcon icon={faUser} /> &nbsp;{" "}
                {appointment?.data?.partnerClientDetails
                  ? "Company Name"
                  : appointment?.data?.clientDetails?.isResidential
                  ? "Client Name"
                  : "Company Name"}
              </p>
              <span>
                {appointment?.data?.partnerClientDetails
                  ? appointment?.data?.partnerClientDetails?.companyName
                  : appointment?.data?.clientDetails?.isResidential
                  ? appointment?.data?.clientDetails?.name
                  : appointment?.data?.clientDetails?.companyName || ""}
              </span>
              <p className="mt-10">
                <FontAwesomeIcon icon={faHashtag} /> &nbsp;
                {<FormattedMessage id="WorkOrder.WoNo" />}#
              </p>
              <span>{appointment?.data?.woNumber || ""}</span>
              <p className="mt-10">
                <FontAwesomeIcon icon={faHashtag} /> &nbsp;
                {<FormattedMessage id="Dashboard.Quotes.QuoteNumber" />}#
              </p>
              <span> {appointment?.data?.estimateNo || ""}</span>
            </Card>
            <Card
              title={<FormattedMessage id="ClientDetails.BillingAddress" />}
              size="small"
              className="mt-10"
            >
              {appointment?.data?.partnerClientDetails ? (
                <>
                  <p>
                    {[
                      appointment?.data?.partnerClientDetails?.billingAddress
                        ?.address1,
                      appointment?.data?.partnerClientDetails?.billingAddress
                        ?.address2,
                      appointment?.data?.partnerClientDetails?.billingAddress
                        ?.city,
                      appointment?.data?.partnerClientDetails?.billingAddress
                        ?.province,
                      appointment?.data?.partnerClientDetails?.billingAddress
                        ?.country,
                      appointment?.data?.partnerClientDetails?.billingAddress
                        ?.zip,
                    ]
                      .filter(Boolean)
                      .join(", ")}
                  </p>
                </>
              ) : (
                <>
                  <p>
                    {[
                      appointment?.data?.clientDetails?.billingAddress
                        ?.address1,
                      appointment?.data?.clientDetails?.billingAddress
                        ?.address2,
                      appointment?.data?.clientDetails?.billingAddress?.city,
                      appointment?.data?.clientDetails?.billingAddress
                        ?.province,
                      appointment?.data?.clientDetails?.billingAddress?.country,
                      appointment?.data?.clientDetails?.billingAddress?.zip,
                    ]
                      .filter(Boolean)
                      .join(", ")}
                  </p>
                </>
              )}
            </Card>
            <Card
              title={<FormattedMessage id="ClientDetails.DeliveryAddress" />}
              size="small"
              className="mt-10"
            >
              <p>
                {appointment?.data?.partnerClientDetails ? (
                  <>
                    <b>
                      {appointment?.data?.partnerClientDetails
                        ?.billingContactPerson || ""}
                    </b>
                    <br />
                    {appointment?.data?.partnerClientDetails?.billingPhone ||
                      ""}
                    <br />
                    {appointment?.data?.partnerClientDetails?.billingEmail ||
                      ""}
                    <br />
                    {[
                      appointment?.data?.partnerClientDetails?.shippingAddress
                        ?.address1,
                      appointment?.data?.partnerClientDetails?.shippingAddress
                        ?.address2,
                      appointment?.data?.partnerClientDetails?.shippingAddress
                        ?.city,
                      appointment?.data?.partnerClientDetails?.shippingAddress
                        ?.province,
                      appointment?.data?.partnerClientDetails?.shippingAddress
                        ?.country,
                      appointment?.data?.partnerClientDetails?.shippingAddress
                        ?.zip,
                    ]
                      .filter(Boolean)
                      .join(", ")}
                  </>
                ) : appointment?.data?.clientDetails?.isResidential ? (
                  <>
                    <b>{appointment?.data?.clientDetails.name || ""}</b>
                    <br />
                    {appointment?.data?.clientDetails.phone || ""}
                    <br />
                    {[
                      appointment?.data?.clientDetails?.shippingAddress
                        ?.address1,
                      appointment?.data?.clientDetails?.shippingAddress
                        ?.address2,
                      appointment?.data?.clientDetails?.shippingAddress?.city,
                      appointment?.data?.clientDetails?.shippingAddress
                        ?.province,
                      appointment?.data?.clientDetails?.shippingAddress
                        ?.country,
                      appointment?.data?.clientDetails?.shippingAddress?.zip,
                    ]
                      .filter(Boolean)
                      .join(", ")}
                  </>
                ) : (
                  <>
                    <b>
                      {appointment?.data?.clientDetails?.billingCPName || ""}
                    </b>
                    <br />
                    {appointment?.data?.clientDetails?.billingCPPhone || ""}
                    <br />
                    {[
                      appointment?.data?.clientDetails?.shippingAddress
                        ?.address1,
                      appointment?.data?.clientDetails?.shippingAddress
                        ?.address2,
                      appointment?.data?.clientDetails?.shippingAddress?.city,
                      appointment?.data?.clientDetails?.shippingAddress
                        ?.province,
                      appointment?.data?.clientDetails?.shippingAddress
                        ?.country,
                      appointment?.data?.clientDetails?.shippingAddress?.zip,
                    ]
                      .filter(Boolean)
                      .join(", ")}
                  </>
                )}
              </p>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}
export default AppointmentDetails;
